import { SelectorRowAgendaVariantType } from '../../../../../../components/selectorRowAgenda/types/selectorRowAgenda';
import { SelectorRowAgendaState } from '../../../../../../components/selectorRowAgenda/types/state';
import { CheckboxVariantType, RadioButtonGroupVariantType } from '../../variants';
import { amountCommonStyles, amountContainerCommonStyles, amountSubtitleCommonStyles, avatarContainerCommonStyles, contentSubtitleCommonStyles, dataContainerCommonStyles, elementsContainerCommonStyles, infoContainerCommonStyles, inputCommonStyles, lineSeparatorCommonStyles, parentContainerCommonStyles, selectorContainerCommonStyles, subtitleCommonStyles, tagCommonStyles, titleCommonStyles, } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [SelectorRowAgendaVariantType.REGULAR]: {
            [SelectorRowAgendaState.DEFAULT]: {
                parentContainer: {
                    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                dataContainer: {
                    ...dataContainerCommonStyles(FOUNDATIONS, FONT),
                },
                lineSeparator: {
                    ...lineSeparatorCommonStyles(FOUNDATIONS, FONT),
                },
                avatarContainer: {
                    ...avatarContainerCommonStyles(FOUNDATIONS, FONT),
                },
                elementsContainer: {
                    ...elementsContainerCommonStyles(FOUNDATIONS, FONT),
                },
                infoContainer: {
                    ...infoContainerCommonStyles(FOUNDATIONS, FONT),
                },
                amountContainer: {
                    ...amountContainerCommonStyles(FOUNDATIONS, FONT),
                },
                tag: {
                    ...tagCommonStyles(FOUNDATIONS, FONT),
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                },
                content: {
                    ...contentSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                subtitle: {
                    ...subtitleCommonStyles(FOUNDATIONS, FONT),
                },
                amount: {
                    ...amountCommonStyles(FOUNDATIONS, FONT),
                },
                amountSubtitle: {
                    ...amountSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                input: {
                    ...inputCommonStyles(FOUNDATIONS, FONT),
                },
            },
            [SelectorRowAgendaState.PRESSED]: {
                parentContainer: {
                    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                dataContainer: {
                    ...dataContainerCommonStyles(FOUNDATIONS, FONT),
                },
                lineSeparator: {
                    ...lineSeparatorCommonStyles(FOUNDATIONS, FONT),
                },
                avatarContainer: {
                    ...avatarContainerCommonStyles(FOUNDATIONS, FONT),
                },
                elementsContainer: {
                    ...elementsContainerCommonStyles(FOUNDATIONS, FONT),
                },
                infoContainer: {
                    ...infoContainerCommonStyles(FOUNDATIONS, FONT),
                },
                amountContainer: {
                    ...amountContainerCommonStyles(FOUNDATIONS, FONT),
                },
                tag: {
                    ...tagCommonStyles(FOUNDATIONS, FONT),
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                },
                content: {
                    ...contentSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                subtitle: {
                    ...subtitleCommonStyles(FOUNDATIONS, FONT),
                },
                amount: {
                    ...amountCommonStyles(FOUNDATIONS, FONT),
                },
                amountSubtitle: {
                    ...amountSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                input: {
                    ...inputCommonStyles(FOUNDATIONS, FONT),
                },
            },
            [SelectorRowAgendaState.SELECTED]: {
                parentContainer: {
                    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_comp_forms_selectorrowagenda_selected_bg,
                },
                dataContainer: {
                    ...dataContainerCommonStyles(FOUNDATIONS, FONT),
                },
                lineSeparator: {
                    ...lineSeparatorCommonStyles(FOUNDATIONS, FONT),
                },
                avatarContainer: {
                    ...avatarContainerCommonStyles(FOUNDATIONS, FONT),
                },
                elementsContainer: {
                    ...elementsContainerCommonStyles(FOUNDATIONS, FONT),
                },
                infoContainer: {
                    ...infoContainerCommonStyles(FOUNDATIONS, FONT),
                },
                amountContainer: {
                    ...amountContainerCommonStyles(FOUNDATIONS, FONT),
                },
                tag: {
                    ...tagCommonStyles(FOUNDATIONS, FONT),
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                },
                content: {
                    ...contentSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                subtitle: {
                    ...subtitleCommonStyles(FOUNDATIONS, FONT),
                },
                amount: {
                    ...amountCommonStyles(FOUNDATIONS, FONT),
                },
                amountSubtitle: {
                    ...amountSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                selectionIndicatorContainer: {
                    ...selectorContainerCommonStyles(FOUNDATIONS, FONT),
                },
                selectorContainer: {
                    ...selectorContainerCommonStyles(FOUNDATIONS, FONT),
                },
                checkbox: {
                    variant: CheckboxVariantType.REGULAR,
                },
                radioButton: {
                    variant: RadioButtonGroupVariantType.REGULAR,
                },
                input: {
                    ...inputCommonStyles(FOUNDATIONS, FONT),
                },
            },
            [SelectorRowAgendaState.UNSELECTED]: {
                parentContainer: {
                    ...parentContainerCommonStyles(FOUNDATIONS, FONT),
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                lineSeparator: {
                    ...lineSeparatorCommonStyles(FOUNDATIONS, FONT),
                },
                dataContainer: {
                    ...dataContainerCommonStyles(FOUNDATIONS, FONT),
                },
                avatarContainer: {
                    ...avatarContainerCommonStyles(FOUNDATIONS, FONT),
                },
                elementsContainer: {
                    ...elementsContainerCommonStyles(FOUNDATIONS, FONT),
                },
                infoContainer: {
                    ...infoContainerCommonStyles(FOUNDATIONS, FONT),
                },
                amountContainer: {
                    ...amountContainerCommonStyles(FOUNDATIONS, FONT),
                },
                tag: {
                    ...tagCommonStyles(FOUNDATIONS, FONT),
                },
                title: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                },
                content: {
                    ...contentSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                subtitle: {
                    ...subtitleCommonStyles(FOUNDATIONS, FONT),
                },
                amount: {
                    ...amountCommonStyles(FOUNDATIONS, FONT),
                },
                amountSubtitle: {
                    ...amountSubtitleCommonStyles(FOUNDATIONS, FONT),
                },
                selectionIndicatorContainer: {
                    ...selectorContainerCommonStyles(FOUNDATIONS, FONT),
                },
                selectorContainer: {
                    ...selectorContainerCommonStyles(FOUNDATIONS, FONT),
                },
                checkbox: {
                    variant: CheckboxVariantType.REGULAR,
                },
                radioButton: {
                    variant: RadioButtonGroupVariantType.REGULAR,
                },
                input: {
                    ...inputCommonStyles(FOUNDATIONS, FONT),
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map